<template lang="pug">
    #app.main(:class='loading ? "loading" : ""')
        header-public-component
        .page-content
            router-view        
        footer-public-component
    </template>
<script>
import FooterPublicComponent from './components/FooterPublicComponent.vue';
import HeaderPublicComponent from './components/HeaderPublicComponent.vue';
import SidebarPublicComponent from './components/SidebarPublicComponent.vue';
import BUS from '@/utils/bus.utils';

export default {
    name: 'AppPublic',
    components: {
        FooterPublicComponent,
        HeaderPublicComponent,
        SidebarPublicComponent,
    },
    data() {
        return {
            loading: false,
            modalRegerarTermo: false,
        };
    },
    computed: {

    },

    methods: {

    },

    created() {
        BUS.$on('loading:show', () => {
            this.loading = true;
        });
        BUS.$on('loading:hide', () => {
            this.loading = false;
        });


    },


};
</script>

<style scoped>
:root {

    --primary: #3AAA1B;
    --primary-100: #E6FAD0;

    --primary-gray: rgb(238 238 238);
    --primary-white: whitesmoke;
    --primary-green: rgb(65 183 57);
    --primary-light-green: rgba(65, 183, 57, 0.292);
    --primary-smoke: rgb(255 255 255 / 51%);
    --primary-red: red;
    --primary-light-red: #e4614f;
    --primary-disable-red: rgb(228 97 79 / 33%);
    --primary-light-smoke: rgb(118 118 118);
    --primary-dark-smoke: rgb(116 113 113 / 43%);
    --primar-disable-gray: rgb(232 229 229);
    --primary-black: hsla(0, 3%, 7%, 0.788);
    --primary-transparent: transparent;
    --secondary-green: rgba(53, 145, 56);
    --secondary-regular-green: #9BE571;
    --secondary-light-green: #E6FAD0;
    --secondary-red: #D63519;
    --secondary-regular-red: #F29971;
    --secondary-light-red: #FDE4D0;
}

.main,
body {
    background-color: var(--primary-gray) !important;
}

#app {
    font-family: Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.page-content {
    height: 75vh; 
}

.loading {
    position: relative;
}

.loading:after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--primary-smoke);
    background-image: url('./assets/loading.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50px 50px;
    content: '';
    z-index: 1000;
}
</style>